
import React from 'react';
import { cn } from '@/lib/utils';
import { basePath } from '@/integrations/supabase/client';
import { useLanguage } from '@/contexts/LanguageContext';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showVersion?: boolean;
  variant?: 'standard' | 'pro';
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className, showVersion = false, variant = 'standard' }) => {
  const logoPath = `${basePath}/lovable-uploads/4940a812-afab-4024-9e71-e5facec11507.png`;
  const { language } = useLanguage();
  
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-16'
  };

  return (
    <div className={cn('flex items-center', className)}>
      <img 
        src={logoPath} 
        alt="BEAMEvaluate Logo" 
        className={cn(sizeClasses[size])}
        onError={(e) => {
          console.error("Logo failed to load from path:", logoPath);
          console.log("Attempting fallback...");
          // You could set a fallback image here if needed
          // (e.target as HTMLImageElement).src = fallbackImagePath;
        }}
      />
      {showVersion && (
        <span className={cn("text-sm font-semibold ml-2", {
          "text-gray-600": variant === 'standard',
          "text-blue-700": variant === 'pro'
        })}>
          {variant === 'pro' 
            ? (language === 'zh' ? 'BEAMEvaluate 专业版V2.1 - AI & 区块链' : 'BEAMEvaluate Pro 2.1 - AI & Blockchain') 
            : (language === 'zh' ? 'BEAMEvaluate 轻量版V1.0' : 'BEAMEvaluate Lite 1.0')}
        </span>
      )}
    </div>
  );
};

export default Logo;
